import { LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as ExportTicketIconInactive } from 'app/assets/img/export-excel-icon-inactive.svg';
import { ReactComponent as ExportTicketIcon } from 'app/assets/img/export-excel-icon.svg';
import React, {
  MutableRefObject,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Dropdown, Form, Typography } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import { ReactComponent as FilterIcon } from 'app/assets/img/filter-icon.svg';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import StyledSlider from 'app/components/StyledSlider';
import StyledTabs from 'app/components/StyledTabs';
import { Permission } from 'app/hooks/usePermission';
import useWindowSize from 'app/hooks/useWindowSize';
import { selectOrderCount } from 'app/pages/Account/ListOrder/slice/selectors';
import { I_PayloadGetListOrder } from 'app/pages/Account/ListOrder/slice/types';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { GET_PARKS, useHomeSlice } from 'app/pages/Home/slice';
import { selectListPark } from 'app/pages/Home/slice/selectors';
import ListCancelTicket from 'app/pages/NewAccount/PurchaseHistory/components/ListCancelTicket';
import ListPendingTicket from 'app/pages/NewAccount/PurchaseHistory/components/ListPendingTicket';
import StyledDatePicker from 'app/pages/NewAccount/components/StyledDatePicker';
import StyledSearchInput from 'app/pages/NewAccount/components/StyledSearchInput';
import StyledSelect, {
  CustomSelect,
  MobileStyledSelect,
} from 'app/pages/NewAccount/components/StyledSelect';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import {
  exportHistoryExcelApi,
  getDataAgentApi,
  getDataSelectTicketApi,
} from 'app/services/checkTicketApi';
import * as _ from 'lodash';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { I_OptionsGetList, objectType } from 'types';
import { cleanObject } from 'utils/helper';
import { I_Agents } from '../CheckTickets/slice/types';
import { Layout } from '../layouts';
import ListSuccessTicket from './components/ListSuccessTicket';
import { ListTicketViewRef, OrderState } from 'app/pages/NewAccount/types';
import DownLoadExcel from 'app/pages/Agent/TransactionHistory/_DownLoadExcel';
import InfinitySelect from 'app/components/SelectMulti/InfinitySelect';
import ListWaitForComplete from 'app/pages/NewAccount/PurchaseHistory/components/ListWaitForComplete';
import ListWaitForCancelApprove from 'app/pages/NewAccount/PurchaseHistory/components/ListWaitForCancelApprove';
import { BP_TYPE, SESSION_MESSAGE } from 'utils/constants';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { getDayOfWeekString } from 'utils/time';
import styled from 'styled-components';
import { convertVItoEN } from '../CheckTickets/helper';
import useAllocatedDebt from 'app/hooks/useAllocatedDebt';
import PurcharseHistoryDetail from './components/PurchaseHistoryDetail';
import RangeDatePickerCustom from '../CheckTickets/RangeDatePickerCustom';

export enum ORDER_SOURCES {
  B2B = '0',
  API = '1',
}

export const ORDER_SOURCE_OPTIONS = [
  { value: '', labelKey: 'b2b.text.all' },
  { value: ORDER_SOURCES.B2B, labelKey: 'b2b.order.source' },
  { value: ORDER_SOURCES.API, labelKey: 'b2b.order.api.source' },
];

type FilterDataView = {
  searchOrderValue: string;
  searchParkID: string;
  orderDateFrom: moment.Moment | null;
  orderDateTo: moment.Moment | null;
  ticketIdView: number[];
  agentId: string;
  successState: string;
  totalMoneyFrom: any;
  totalMoneyTo: any;
  orderType?: string;
  representative: string;
  authorizedBizId?: string | number;
  mailAuthorizedBiz?: string | number;
  approvedCode?: string;
  orderSource?: ORDER_SOURCES;
};

type SearchComponentProps = {
  travelLocation: {
    value: string;
    label: string;
  }[];
  searchSuccess: RefObject<ListTicketViewRef>;
  searchPending: RefObject<ListTicketViewRef>;
  searchCancel: RefObject<ListTicketViewRef>;
  searchWaitCancel: RefObject<ListTicketViewRef>;
  searchWaitComplete: RefObject<ListTicketViewRef>;
  setFilters?: (filters: Partial<FilterDataView>) => void;
  filters?: Partial<FilterDataView>;
  tab?: string;
  handleExportExcel?: () => void;
  listOrderType?: {
    value: string;
    label: any;
  }[];
  preventApiCall: boolean;
};

export const formatDate = (
  date: moment.Moment,
  translation: objectType | undefined,
) => {
  const dayOfWeek = getDayOfWeekString(date, translation);
  // Format the rest of the date
  return `${dayOfWeek} ${date.format('(DD/MM/YYYY)')}`;
};
const DesktopSearchComponent = ({
  travelLocation,
  searchSuccess,
  searchPending,
  searchCancel,
  searchWaitCancel,
  searchWaitComplete,
  tab,
  filters,
  setFilters,
  listOrderType,
  preventApiCall,
}: SearchComponentProps) => {
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const [dataAgent, setDataAgent] = useState([]);
  const listStatus = [
    { value: '', label: translations?.['b2b.text.all'] },
    {
      id: 2,
      label: translations?.['b2b.txt.ticket-exporting'],
      value: 'SyncVGS',
    },
    {
      id: 3,
      label: translations?.['b2b.txt.ticket-exported'],
      value: 'success',
    },
  ];
  const getDataAgent = useCallback(async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!_.isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        const resAgentsEx: any = isSaleMng
          ? [
              {
                value: '',
                label: translations?.['b2b.text.all'],
              },
              ...resAgents,
            ]
          : resAgents;
        setDataAgent(resAgentsEx);
      }
    } catch (error) {}
  }, [isSaleMng, translations]);

  const [allocatedSearch, setAllocatedSearch] = useState('');

  const { result: allocatedDebtData } = useAllocatedDebt({
    IIFE: isProxyBuyer,
    search: allocatedSearch,
  });

  useEffect(() => {
    if (preventApiCall) return;
    getDataAgent();
  }, [getDataAgent]);

  return (
    <Form
      style={{
        display: 'flex',
        marginBottom: 16,
      }}
    >
      <StyledStack direction={'column'} rowGap={'16px'}>
        <StyledStack columnGap={'18px'} justifyContent={'space-between'}>
          <RangeDatePickerContainer>
            <RangeDatePickerCustom
              placeholder={
                translations ? translations['b2b.txt.date-order'] : ''
              }
              minDate={null}
              isClearable
              startDateInit={filters?.orderDateFrom?.toDate()}
              endDateInit={filters?.orderDateTo?.toDate()}
              onChange={([start, end]) => {
                setFilters?.({
                  ...filters,
                  orderDateFrom: start ? moment(start) : null,
                  orderDateTo: end ? moment(end) : null,
                });
              }}
            />
          </RangeDatePickerContainer>
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.searchParkID}
            suffixIcon={<ArrowDownIcon />}
            style={{ flex: 1, maxWidth: '25%' }}
            placeholder={translations ? translations['b2c.txt.park'] : ''}
            onChange={val =>
              setFilters?.({
                ...filters,
                searchParkID: val as string,
              })
            }
            options={travelLocation}
            allowClear
          />
          <StyledSearchInput
            placeholder={
              translations ? translations['b2c.txt.orderNumber'] : ''
            }
            onChange={e =>
              setFilters?.({
                ...filters,
                searchOrderValue: e.target.value ?? '',
              })
            }
            onBlur={() => {
              setFilters?.({
                ...filters,
                searchOrderValue: filters?.searchOrderValue?.trim(),
              });
            }}
            value={filters?.searchOrderValue}
            style={{ flex: 1, maxWidth: '25%' }}
          />
          <InfinitySelect
            preventApiCall={preventApiCall}
            onChange={val => {
              setFilters?.({
                ...filters,
                ticketIdView: val,
              });
            }}
            placeholder={translations?.['b2b.booking.products']}
            value={filters?.ticketIdView}
            getDataApi={getDataSelectTicketApi}
            height="44px"
            style={{ flex: 1, maxWidth: '25%' }}
          />
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(input)
            }
            showSearch
            isFocus
            suffixIcon={<ArrowDownIcon />}
            placeholder={
              translations ? translations['b2b.txt.list-order-type'] : ''
            }
            value={filters?.orderType}
            onChange={val => {
              setFilters?.({
                ...filters,
                orderType: val as string,
              });
            }}
            options={listOrderType ?? []}
            allowClear
          />
        </StyledStack>

        <StyledStack columnGap={'18px'} alignItem={'center'}>
          <StyledSlider
            onChangeCallBack={value => {
              setFilters?.({
                ...filters,
                totalMoneyFrom: value[0],
                totalMoneyTo: value[1],
              });
            }}
          />
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            disabled={tab !== 'tab-1'}
            value={tab !== 'tab-1' ? undefined : filters?.successState}
            suffixIcon={<ArrowDownIcon />}
            placeholder={
              translations ? translations['b2b.txt.ticket-status'] : ''
            }
            onChange={val =>
              setFilters?.({ ...filters, successState: val as string })
            }
            options={listStatus}
            style={{
              flex: 1,
              maxWidth: 210,
            }}
            allowClear
          />
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.agentId}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.orderer'] : ''}
            onChange={val =>
              setFilters?.({ ...filters, agentId: val as string })
            }
            options={dataAgent}
            allowClear
            style={{ flex: 1, maxWidth: 210 }}
          />
          <StyledSearchInput
            placeholder={
              translations?.['b2c.txt.representative'] ?? 'Người đại diện'
            }
            onChange={e =>
              setFilters?.({
                ...filters,
                representative: e?.target?.value || ('' as string),
              })
            }
            value={filters?.representative}
            style={{ flex: 1, maxWidth: '25%' }}
          />
          {!isProxyBuyer && (
            <StyledSelect
              filterOption={(input, option) =>
                (convertVItoEN(option?.label) ?? '').includes(
                  convertVItoEN(input),
                )
              }
              showSearch
              isFocus
              value={filters?.orderSource}
              suffixIcon={<ArrowDownIcon />}
              placeholder={translations ? translations['b2b.txt.source'] : ''}
              onChange={val =>
                setFilters?.({ ...filters, orderSource: val as ORDER_SOURCES })
              }
              options={ORDER_SOURCE_OPTIONS.map(i => ({
                value: i.value,
                label: translations?.[i.labelKey] ?? '',
              }))}
              allowClear
              style={{ flex: 1, maxWidth: 210 }}
            />
          )}
        </StyledStack>

        {!isProxyBuyer && (
          <StyledStack>
            <StyledButton
              bgColor="white"
              border="1px solid #F8B117"
              textColor="#F8B117"
              style={{ flex: 1, height: 44, maxWidth: 124 }}
              onClick={() => {
                const data = {
                  search: filters?.searchOrderValue || undefined,
                  park: filters?.searchParkID,
                  ...filters,
                  ticketId: filters?.ticketIdView?.join(','),
                  ticketIdView: undefined,
                  page: 1,
                  orderDateFrom: filters?.orderDateFrom?.format('YYYY-MM-DD'),
                  orderDateTo:
                    filters?.orderDateTo?.format('YYYY-MM-DD') ??
                    filters?.orderDateFrom?.format('YYYY-MM-DD'),
                  // limit: 20,
                };
                searchSuccess.current?.search(data);
                searchPending.current?.search(data);
                searchCancel.current?.search(data);
                searchWaitCancel.current?.search(data);
                searchWaitComplete.current?.search(data);
              }}
            >
              {translations ? translations['b2c.txt.search'] : ''}
            </StyledButton>
          </StyledStack>
        )}

        {isProxyBuyer && (
          <StyledStack columnGap={'18px'} alignItem={'center'}>
            <StyledSelect
              filterOption={false}
              onSearch={value => {
                setAllocatedSearch(value);
              }}
              showSearch
              isFocus
              value={filters?.authorizedBizId}
              suffixIcon={<ArrowDownIcon />}
              placeholder={
                translations ? translations['b2b.txt.authorized'] : ''
              }
              onChange={val => {
                setAllocatedSearch('');
                setFilters?.({ ...filters, authorizedBizId: val as string });
              }}
              options={allocatedDebtData?.map(i => ({
                value: i?.id,
                label: i?.name,
              }))}
              allowClear
              style={{ flex: 1, maxWidth: 210 }}
            />
            <StyledSearchInput
              placeholder={translations?.['b2b.txt.ticketRecipient'] ?? ''}
              onChange={e => {
                setFilters?.({
                  ...filters,
                  mailAuthorizedBiz: e?.target?.value || ('' as string),
                });
              }}
              value={filters?.mailAuthorizedBiz}
              style={{ flex: 1, maxWidth: '25%' }}
            />
            {tab && ['tab-1', 'tab-2', 'tab-3'].includes(tab) && (
              <StyledSearchInput
                placeholder={translations?.['b2b.txt.approvalCode'] ?? ''}
                onChange={e => {
                  setFilters?.({
                    ...filters,
                    approvedCode: e?.target?.value || ('' as string),
                  });
                }}
                value={filters?.approvedCode}
                style={{ flex: 1, maxWidth: '25%' }}
                maxLength={200}
              />
            )}
            <StyledButton
              bgColor="white"
              border="1px solid #F8B117"
              textColor="#F8B117"
              style={{ flex: 1, height: 44, maxWidth: 124 }}
              onClick={() => {
                const data = {
                  search: filters?.searchOrderValue || undefined,
                  // orderDate: filters?.searchDate?.format('YYYY-MM-DD'),
                  park: filters?.searchParkID,
                  ...filters,
                  ticketId: filters?.ticketIdView?.join(','),
                  ticketIdView: undefined,
                  page: 1,
                  orderDateFrom: filters?.orderDateFrom?.format('YYYY-MM-DD'),
                  orderDateTo:
                    filters?.orderDateTo?.format('YYYY-MM-DD') ??
                    filters?.orderDateFrom?.format('YYYY-MM-DD'),
                  // limit: 20,
                };
                const { approvedCode, ...restDataRequest } = data;
                searchSuccess.current?.search(data);
                searchPending.current?.search(data);
                searchCancel.current?.search(data);
                searchWaitCancel.current?.search(restDataRequest);
                searchWaitComplete.current?.search(restDataRequest);
              }}
            >
              {translations ? translations['b2c.txt.search'] : ''}
            </StyledButton>
          </StyledStack>
        )}
      </StyledStack>
    </Form>
  );
};

const MobileTabletSearchComponent = (
  props: SearchComponentProps & {
    setActiveKeyTab: (val: string) => void;
    disableExportPdf: boolean;
  },
) => {
  const {
    setActiveKeyTab,
    searchCancel,
    searchSuccess,
    searchPending,
    handleExportExcel,
    searchWaitComplete,
    searchWaitCancel,
    preventApiCall,
    disableExportPdf,
  } = props;
  const translations = useSelector(selectTranslations);
  const orderCount = useSelector(selectOrderCount);
  const location = useLocation();
  const history = useHistory();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab || searchParams.get('route') || 'tab-2';
  const [tab, setTab] = useState(tabRoute);
  const [menuVisible, setMenuVisible] = useState(false);
  const { device } = useWindowSize();
  const [loading, setLoading] = useState(false);

  const getOrderState = () => {
    switch (tab) {
      case 'tab-1':
        return 'success';
      case 'tab-2':
        return 'paymentPending';
      case 'tab-3':
        return 'cancelled';
    }
  };

  const productListCached = useRef<any>([]);
  const orderedListCached = useRef<any>([]);
  const allocatedListCached = useRef<any>([]);

  return (
    <Form
      style={{
        marginBottom: 16,
        display: 'flex',
      }}
    >
      <div
        style={{
          marginRight: 8,
          width: device !== 'mobile' ? '220px' : '186px',
        }}
      >
        <MobileStyledSelect
          value={tab}
          onChange={val => {
            if (val === 'tab-1') {
              searchSuccess.current?.search({});
            } else if (val === 'tab-2') {
              searchPending.current?.search({});
            } else if (val === 'tab-3') {
              searchCancel.current?.search({});
            } else if (val === 'tab-4') {
              searchWaitComplete.current?.search({});
            } else if (val === 'tab-5') {
              searchWaitCancel.current?.search({});
            }
            setTab(val as string);
            setActiveKeyTab(val as string);
            history.push(`?route=${val}`);
          }}
          suffixIcon={<ArrowDownIcon />}
          style={{ width: '100%' }}
          options={[
            {
              value: 'tab-1',
              label:
                (translations ? translations['b2c.txt.success'] : '') +
                ' (' +
                (orderCount?.success ?? 0) +
                ')',
            },
            {
              value: 'tab-2',
              label:
                (translations ? translations['b2c.txt.pending'] : '') +
                ' (' +
                (orderCount?.paymentPending ?? 0) +
                ')',
            },
            {
              value: 'tab-3',
              label:
                (translations ? translations['b2c.txt.cancelled'] : '') +
                ' (' +
                (orderCount?.cancelled ?? 0) +
                ')',
            },
            {
              value: 'tab-4',
              label:
                (translations ? translations['b2c.txt.wait-complete'] : '') +
                ' (' +
                (orderCount?.init ?? 0) +
                ')',
            },
            {
              value: 'tab-5',
              label:
                (translations
                  ? translations['b2c.txt.wait-approve-cancel']
                  : '') +
                ' (' +
                ((orderCount?.pendingApprove ?? 0) +
                  (orderCount?.approved ?? 0)) +
                ')',
            },
          ]}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flex: device === 'mobile' ? 1 : undefined,
          width: device === 'mobile' ? '55%' : '85%',
          justifyContent: 'flex-end',
        }}
      >
        <StyledStack justifyContent={'flex-end'}>
          <Dropdown
            visible={menuVisible}
            trigger={['click']}
            onVisibleChange={visible => setMenuVisible(visible)}
            getPopupContainer={trigger => trigger.parentNode as HTMLElement}
            overlayStyle={{ zIndex: 3 }}
            destroyPopupOnHide
            overlay={
              <MobileSearchOverlay
                {...props}
                setMenuVisible={setMenuVisible}
                preventApiCall={preventApiCall}
                productListCached={productListCached}
                orderedListCached={orderedListCached}
                allocatedListCached={allocatedListCached}
              />
            }
          >
            <StyledButton
              bgColor="#fff"
              style={{
                border: '1px solid #EDEDED',
                borderRadius: 10,
                width: 41,
                height: 41,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
              }}
            >
              <FilterIcon width={16} height={16} color="#000" />
            </StyledButton>
          </Dropdown>
          <StyledButton
            bgColor="#fff"
            style={{
              border: '1px solid #EDEDED',
              borderRadius: 10,
              width: 41,
              height: 41,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              marginLeft: 8,
            }}
            onClick={() => !disableExportPdf && handleExportExcel?.()}
          >
            {loading ? (
              <LoadingOutlined
                style={{ fontSize: 16, color: '#F8B117' }}
                spin
              />
            ) : (
              <StyledExportTicketIcon
                active={!disableExportPdf}
                width={16}
                height={16}
              />
            )}
          </StyledButton>
        </StyledStack>
      </div>
    </Form>
  );
};

const MobileSearchOverlay = ({
  tab,
  travelLocation,
  searchSuccess,
  searchPending,
  searchCancel,
  searchWaitCancel,
  searchWaitComplete,
  setMenuVisible,
  filters,
  setFilters,
  listOrderType,
  preventApiCall,
  productListCached,
  orderedListCached,
  allocatedListCached,
}: SearchComponentProps & {
  setMenuVisible: (show: boolean) => void;
  preventApiCall: boolean;
  productListCached: MutableRefObject<any[]>;
  orderedListCached: MutableRefObject<any[]>;
  allocatedListCached: MutableRefObject<any[]>;
}) => {
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const [dataAgent, setDataAgent] = useState<any>(orderedListCached.current);
  const listStatus = [
    { value: '', label: translations?.['b2b.text.all'] },
    {
      id: 2,
      label: translations?.['b2b.txt.ticket-exporting'],
      value: 'SyncVGS',
    },
    {
      id: 3,
      label: translations?.['b2b.txt.ticket-exported'],
      value: 'success',
    },
  ];

  const [allocatedSearch, setAllocatedSearch] = useState('');

  const { result: allocatedDebtData } = useAllocatedDebt({
    IIFE: isProxyBuyer,
    search: allocatedSearch,
    onSuccess: res => {
      allocatedListCached.current = res;
    },
  });

  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  const getDataAgent = useCallback(async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!_.isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        const resAgentsEx: any = isSaleMng
          ? [
              {
                value: '',
                label: translations?.['b2b.text.all'],
              },
              ...resAgents,
            ]
          : resAgents;
        setDataAgent(resAgentsEx);
        orderedListCached.current = resAgentsEx;
      }
    } catch (error) {}
  }, [isSaleMng, translations, orderedListCached]);

  useEffect(() => {
    if (preventApiCall) return;
    getDataAgent();
  }, [getDataAgent]);

  return (
    <div
      style={{
        padding: '16px',
        backgroundColor: 'white',
        borderRadius: 8,
        boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <RangeDatePickerContainer style={{ marginBottom: 8, width: 267 }}>
        <RangeDatePickerCustom
          placeholder={translations ? translations['b2b.txt.date-order'] : ''}
          minDate={null}
          isClearable
          startDateInit={filters?.orderDateFrom?.toDate()}
          endDateInit={filters?.orderDateTo?.toDate()}
          onChange={([start, end]) => {
            setFilters?.({
              ...filters,
              orderDateFrom: start ? moment(start) : null,
              orderDateTo: end ? moment(end) : null,
            });
          }}
          onCalendarClose={() => {
            setFilters?.({
              ...filters,
              orderDateTo: filters?.orderDateTo ?? filters?.orderDateFrom,
            });
          }}
        />
      </RangeDatePickerContainer>
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.searchParkID}
        suffixIcon={<ArrowDownIcon />}
        style={{ width: 267, marginBottom: 8 }}
        placeholder={translations ? translations['b2c.txt.park'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, searchParkID: val as string })
        }
        options={travelLocation}
        dropdownStyle={{ zIndex: 4 }}
        allowClear
      />
      <StyledSearchInput
        placeholder={translations ? translations['b2c.txt.orderNumber'] : ''}
        style={{
          marginBottom: 8,
          width: '100%',
        }}
        value={filters?.searchOrderValue}
        onChange={e =>
          setFilters?.({
            ...filters,
            searchOrderValue: e.target.value ?? '',
          })
        }
        onBlur={() => {
          setFilters?.({
            ...filters,
            searchOrderValue: filters?.searchOrderValue?.trim(),
          });
        }}
      />
      <InfinitySelect
        preventApiCall={preventApiCall}
        onChange={val => {
          setFilters?.({
            ...filters,
            ticketIdView: val,
          });
        }}
        placeholder={translations?.['b2b.booking.products']}
        value={filters?.ticketIdView}
        getDataApi={getDataSelectTicketApi}
        style={{
          marginBottom: 8,
          width: 267,
        }}
        cachedList={productListCached}
      />
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        suffixIcon={<ArrowDownIcon />}
        placeholder={
          translations ? translations['b2b.txt.list-order-type'] : ''
        }
        value={filters?.orderType}
        onChange={val => {
          setFilters?.({
            ...filters,
            orderType: val as string,
          });
        }}
        options={listOrderType}
        allowClear
        style={{
          marginBottom: 8,
          width: 267,
        }}
      />
      <StyledSlider
        onChangeCallBack={value => {
          setFilters?.({
            ...filters,
            totalMoneyFrom: value[0],
            totalMoneyTo: value[1],
          });
        }}
        containerStyle={{
          margin: '10px 0',
          width: '100%',
        }}
        defaultValue={
          filters?.totalMoneyFrom && filters.totalMoneyTo
            ? [filters?.totalMoneyFrom / 5e7, filters.totalMoneyTo / 5e7]
            : undefined
        }
      />
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        disabled={tab !== 'tab-1'}
        value={tab !== 'tab-1' ? undefined : filters?.successState}
        suffixIcon={<ArrowDownIcon />}
        placeholder={translations ? translations['b2b.txt.ticket-status'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, successState: val as string })
        }
        options={listStatus}
        style={{
          marginBottom: 8,
          width: 267,
        }}
        dropdownStyle={{ zIndex: 4 }}
        allowClear
      />
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.agentId}
        suffixIcon={<ArrowDownIcon />}
        placeholder={translations ? translations['b2b.txt.orderer'] : ''}
        onChange={val => setFilters?.({ ...filters, agentId: val as string })}
        options={dataAgent}
        allowClear
        style={{
          marginBottom: 8,
          width: 267,
        }}
        dropdownStyle={{ zIndex: 4 }}
      />
      <StyledSearchInput
        placeholder={
          translations?.['b2c.txt.representative'] ?? 'Người đại diện'
        }
        onChange={e =>
          setFilters?.({
            ...filters,
            representative: e?.target?.value || ('' as string),
          })
        }
        value={filters?.representative}
        style={{
          marginBottom: 8,
          width: 267,
        }}
      />

      {!isProxyBuyer && (
        <StyledSelect
          filterOption={(input, option) =>
            (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
          }
          showSearch
          isFocus
          value={filters?.orderSource}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.source'] : ''}
          onChange={val =>
            setFilters?.({ ...filters, orderSource: val as ORDER_SOURCES })
          }
          options={ORDER_SOURCE_OPTIONS.map(i => ({
            value: i.value,
            label: translations?.[i.labelKey] ?? '',
          }))}
          allowClear
          style={{
            marginBottom: 8,
            width: 267,
          }}
          dropdownStyle={{ zIndex: 4 }}
        />
      )}

      {isProxyBuyer && (
        <>
          <StyledSelect
            filterOption={false}
            onSearch={value => {
              setAllocatedSearch(value);
            }}
            showSearch
            isFocus
            value={filters?.authorizedBizId}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.authorized'] : ''}
            onChange={val => {
              setAllocatedSearch('');
              setFilters?.({ ...filters, authorizedBizId: val as string });
            }}
            options={(allocatedDebtData ?? allocatedListCached.current)?.map(
              i => ({
                value: i?.id,
                label: i?.name,
              }),
            )}
            allowClear
            style={{
              marginBottom: 8,
              width: 267,
            }}
          />
          <StyledSearchInput
            placeholder={translations?.['b2b.txt.ticketRecipient'] ?? ''}
            onChange={e => {
              setFilters?.({
                ...filters,
                mailAuthorizedBiz: e?.target?.value || ('' as string),
              });
            }}
            value={filters?.mailAuthorizedBiz}
            style={{
              marginBottom: 8,
              width: 267,
            }}
          />
          {tab && ['tab-1', 'tab-2', 'tab-3'].includes(tab) && (
            <StyledSearchInput
              placeholder={translations?.['b2b.txt.approvalCode'] ?? ''}
              onChange={e => {
                setFilters?.({
                  ...filters,
                  approvedCode: e?.target?.value || ('' as string),
                });
              }}
              value={filters?.approvedCode}
              style={{
                marginBottom: 8,
                width: 267,
              }}
            />
          )}
        </>
      )}

      <StyledButton
        bgColor="white"
        border="1px solid #F8B117"
        textColor="#F8B117"
        width={'100%'}
        height={'44px'}
        onClick={() => {
          const data = {
            search: filters?.searchOrderValue || undefined,
            park: filters?.searchParkID,
            ...filters,
            ticketId: filters?.ticketIdView?.join(','),
            ticketIdView: undefined,
            page: 1,
            orderDateFrom: filters?.orderDateFrom?.format('YYYY-MM-DD'),
            orderDateTo:
              filters?.orderDateTo?.format('YYYY-MM-DD') ??
              filters?.orderDateFrom?.format('YYYY-MM-DD'),
          };
          const { approvedCode, ...restDataRequest } = data;
          searchSuccess.current?.search(data);
          searchPending.current?.search(data);
          searchCancel.current?.search(data);
          searchWaitCancel.current?.search(restDataRequest);
          searchWaitComplete.current?.search(restDataRequest);
          setMenuVisible(false);
        }}
      >
        {translations ? translations['b2c.txt.search'] : ''}
      </StyledButton>
    </div>
  );
};

enum MAIN_TABS {
  OVERVIEW = 'overview',
  DETAIL = 'detail',
}

const PurcharseHistory = () => {
  // const searchText = useRef('');
  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const searchSuccess = useRef<ListTicketViewRef>(null);
  const searchPending = useRef<ListTicketViewRef>(null);
  const searchCancel = useRef<ListTicketViewRef>(null);
  const searchWaitComplete = useRef<ListTicketViewRef>(null);
  const searchWaitCancel = useRef<ListTicketViewRef>(null);
  // const [searchDate, setSearchDate] = useState<moment.Moment | null>();
  const { device } = useWindowSize();
  // const [searchParkID, setSearchParkID] = useState<string | undefined>();
  const location = useLocation();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab || searchParams.get('route') || 'tab-2';
  const [activeKeyTab, setActiveKeyTab] = useState<string>(tabRoute);
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const orderCount = useSelector(selectOrderCount);
  const [filters, setFilters] = useState<Partial<FilterDataView>>({});
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const history = useHistory();
  useHomeSlice();
  const infoUser = useSelector(selectInfoUser);

  const [mainTab, setMainTab] = useState(
    (searchParams.get('screen') as MAIN_TABS) ?? MAIN_TABS.OVERVIEW,
  );
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const listPark = useSelector(selectListPark);
  const listOrderType = [
    { value: '', label: translations?.['b2b.text.all'] },
    { value: 'new', label: translations?.['b2b.txt.type-new'] },
    {
      label: translations?.['b2b.txt.type-exchange'],
      value: 'upgrade',
    },
    {
      label: translations?.['b2b.txt.type-cancel'],
      value: 'return',
    },
  ];

  const getOrderState = (): OrderState | undefined => {
    switch (activeKeyTab) {
      case 'tab-1':
        return 'success';
      case 'tab-2':
        return 'paymentPending';
      case 'tab-3':
        return 'cancelled';
      case 'tab-4':
        return 'init';
      case 'tab-5':
        return 'approved,pendingApprove';
    }
  };

  const handleExportExcel = async () => {
    try {
      if (!(orderCountValue > 0)) return;
      setLoadingExcel(true);
      const data = (() => {
        switch (getOrderState()) {
          case 'success':
            return searchSuccess.current?.getCurrentSearchOpt();
          case 'paymentPending':
            return searchPending.current?.getCurrentSearchOpt();
          case 'cancelled':
            return searchCancel.current?.getCurrentSearchOpt();
          case 'init':
            return searchWaitComplete.current?.getCurrentSearchOpt();
          case 'approved,pendingApprove':
            return searchWaitCancel.current?.getCurrentSearchOpt();
        }
      })();

      const resExportExcel = await exportHistoryExcelApi(
        cleanObject(data ?? {}),
      );
      setLoadingExcel(false);
      if (resExportExcel?.data?.success) {
        window.location.href = resExportExcel?.data?.data?.path;
        const newFilters: Partial<FilterDataView> = {
          ticketIdView:
            !!data?.ticketId && data?.ticketId?.length > 0
              ? data?.ticketId?.split(',').map(Number)
              : [],
          successState:
            searchSuccess.current?.getCurrentSearchOpt().successState,
          searchOrderValue: data?.search,
          searchParkID: data?.park,
          // searchDate: data?.orderDate ? moment(data?.orderDate) : undefined,
          orderDateFrom: data?.orderDateFrom
            ? moment(data?.orderDateFrom)
            : undefined,
          orderDateTo:
            data?.orderDateTo ?? data?.orderDateFrom
              ? moment(data?.orderDateTo ?? data?.orderDateFrom)
              : undefined,
          agentId: data?.agentId,
          totalMoneyFrom: data?.totalMoneyFrom,
          totalMoneyTo: data?.totalMoneyTo,
          orderType: data?.orderType,
          representative: data?.representative,
          authorizedBizId: data?.authorizedBizId,
          mailAuthorizedBiz: data?.mailAuthorizedBiz,
          approvedCode: data?.approvedCode,
          orderSource: data?.orderSource,
        };

        setFilters(cleanObject(newFilters));
      }
    } catch (error: any) {
      onOpenDialogNoti({
        type: 'ERROR',
        content: error?.message ?? '',
        isShow: true,
        title: '',
        onCloseDialog: onCloseDialogNoti,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const travelLocation = useMemo(() => {
    return [
      ...[{ value: '', label: translations?.['b2b.text.all'] }],
      ...listPark?.map(item => ({
        value: `${item.id}`,
        label: item.name,
      })),
    ];
  }, [listPark, translations]);

  useEffect(() => {
    dispatch(GET_PARKS());
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    if (
      historyState?.orderState === 'cancelled' &&
      historyState?.payment === 'BankTransfer'
    ) {
      setActiveKeyTab('tab-3');
    }
    if (
      historyState?.orderState === 'success' &&
      historyState?.payment === 'BankTransfer'
    ) {
      setActiveKeyTab('tab-1');
    }
    if (historyState?.tab) {
      setActiveKeyTab(historyState?.tab);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const orderCountValue = useMemo(() => {
    switch (activeKeyTab) {
      case 'tab-1':
        return orderCount?.success;
      case 'tab-2':
        return orderCount?.paymentPending;
      case 'tab-3':
        return orderCount?.cancelled;
      case 'tab-4':
        return orderCount?.init;
      case 'tab-5':
        return (orderCount?.pendingApprove ?? 0) + (orderCount?.approved ?? 0);
    }
  }, [
    activeKeyTab,
    orderCount?.approved,
    orderCount?.cancelled,
    orderCount?.init,
    orderCount?.paymentPending,
    orderCount?.pendingApprove,
    orderCount?.success,
  ]);

  useEffect(() => {
    // if cancel order at page /ticket-refund/info,
    // then back to this component -> show msg cancel successfully
    const showCancelOrderSuccessMsg = () => {
      const sessionMsg = JSON.parse(
        sessionStorage.getItem(SESSION_MESSAGE) ?? '{}',
      );
      sessionStorage.removeItem(SESSION_MESSAGE);
      if (sessionMsg?.message) {
        onOpenDialogNoti({
          type: sessionMsg?.type ?? 'SUCCESS',
          isShow: true,
          title: '',
          content: sessionMsg?.message,
          buttons: [],
          closable: true,
          maskClosable: false,
          onCloseDialog: () => {
            onCloseDialogNoti();
          },
        });
      }
    };

    showCancelOrderSuccessMsg();
  }, [onCloseDialogNoti, onOpenDialogNoti]);

  useEffect(() => {
    if (location?.search?.startsWith('?screen=detail')) return;
    const route = searchParams.get('route');
    const paramRoute = (location.state as any)?.targetTab;
    if (paramRoute) {
      history.push(`?route=${paramRoute}`);
    } else {
      setActiveKeyTab(route || 'tab-2');
    }
  }, [activeKeyTab, history, location.state, searchParams, location.search]);

  const overviewComponent = (
    <LoadingContainer loading={loading || loadingExcel}>
      <div>
        <div
          style={{
            display: device === 'desktop' ? 'block' : 'none',
          }}
        >
          <DesktopSearchComponent
            preventApiCall={device !== 'desktop'}
            searchCancel={searchCancel}
            searchPending={searchPending}
            searchSuccess={searchSuccess}
            searchWaitCancel={searchWaitCancel}
            searchWaitComplete={searchWaitComplete}
            travelLocation={travelLocation}
            setFilters={setFilters}
            filters={filters}
            tab={activeKeyTab}
            listOrderType={listOrderType}
          />
        </div>
        <div
          style={{
            display:
              device === 'mobile' || device === 'tablet' ? 'block' : 'none',
          }}
        >
          <MobileTabletSearchComponent
            preventApiCall={!(device === 'mobile' || device === 'tablet')}
            setActiveKeyTab={setActiveKeyTab}
            searchCancel={searchCancel}
            searchPending={searchPending}
            searchSuccess={searchSuccess}
            searchWaitCancel={searchWaitCancel}
            searchWaitComplete={searchWaitComplete}
            travelLocation={travelLocation}
            setFilters={setFilters}
            filters={filters}
            tab={activeKeyTab}
            handleExportExcel={handleExportExcel}
            listOrderType={listOrderType}
            disableExportPdf={!(orderCountValue > 0)}
          />
        </div>
      </div>
      <div>
        <StyledTabs
          onChange={key => {
            if (key === 'tab-1') {
              searchSuccess.current?.search({});
            } else if (key === 'tab-2') {
              searchPending.current?.search({});
            } else if (key === 'tab-3') {
              searchCancel.current?.search({});
            } else if (key === 'tab-4') {
              searchWaitComplete.current?.search({});
            } else if (key === 'tab-5') {
              searchWaitCancel.current?.search({});
            }
            setActiveKeyTab(key);
            history.push(`?route=${key}`);
          }}
          activeKey={activeKeyTab}
          tabBarStyle={{
            display: device !== 'desktop' ? 'none' : undefined,
            margin: '10px 0',
          }}
          tabBarExtraContent={{
            right: (
              <div style={{ paddingBottom: 8 }}>
                <DownLoadExcel
                  disabled={!(orderCountValue > 0)}
                  onClick={handleExportExcel}
                />
              </div>
            ),
          }}
        >
          <StyledTabs.TabPane
            forceRender
            tab={
              (translations ? translations['b2c.txt.success'] : '') +
              ' (' +
              (orderCount?.success ?? 0) +
              ')'
            }
            key="tab-1"
          >
            <ListSuccessTicket
              ref={searchSuccess}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={
              (translations ? translations['b2c.txt.pending'] : '') +
              ' (' +
              (orderCount?.paymentPending ?? 0) +
              ')'
            }
            key="tab-2"
          >
            <ListPendingTicket
              ref={searchPending}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={
              (translations ? translations['b2c.txt.cancelled'] : '') +
              ' (' +
              (orderCount?.cancelled ?? 0) +
              ')'
            }
            key="tab-3"
          >
            <ListCancelTicket
              ref={searchCancel}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={
              (translations ? translations['b2c.txt.wait-complete'] : '') +
              ' (' +
              (orderCount?.init ?? 0) +
              ')'
            }
            key="tab-4"
          >
            <ListWaitForComplete
              ref={searchWaitComplete}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={
              (translations
                ? translations['b2c.txt.wait-approve-cancel']
                : '') +
              ' (' +
              ((orderCount?.pendingApprove ?? 0) +
                (orderCount?.approved ?? 0)) +
              ')'
            }
            key="tab-5"
          >
            <ListWaitForCancelApprove
              ref={searchWaitCancel}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
        </StyledTabs>
      </div>
    </LoadingContainer>
  );

  return (
    <Layout
      title={translations ? translations['b2c.txt.order-history'] : ''}
      menuActive={ACCOUNT_MNG_MENU.PURCHASE_HISTORY}
    >
      {isProxyBuyer ? (
        overviewComponent
      ) : (
        <StyledTabs
          activeKey={mainTab}
          onChange={tab => {
            const targetTab = tab as MAIN_TABS;
            setMainTab(targetTab);
            history.replace(
              targetTab === MAIN_TABS.DETAIL
                ? '/account?screen=detail'
                : `/account?route=${activeKeyTab}`,
            );
          }}
        >
          <StyledTabs.TabPane
            key={MAIN_TABS.OVERVIEW}
            tab={translations?.['b2b.txt.overview']?.toUpperCase() ?? ''}
          >
            {overviewComponent}
          </StyledTabs.TabPane>

          <StyledTabs.TabPane
            key={MAIN_TABS.DETAIL}
            tab={translations?.['b2b.txt.detail']?.toUpperCase() ?? ''}
          >
            <PurcharseHistoryDetail />
          </StyledTabs.TabPane>
        </StyledTabs>
      )}
    </Layout>
  );
};

export default PurcharseHistory;

const StyledExportTicketIcon = styled(ExportTicketIconInactive)<{
  active: boolean;
}>`
  path {
    fill: ${props => (props.active ? '#FAB317' : '#d9d9d9')};
  }
`;

const RangeDatePickerContainer = styled.div`
  width: 28%;
  .range-picker-container {
    width: 100%;
  }
  .react-datepicker__close-icon {
    right: 5px;
  }
  .date-picker {
    height: 44px;
  }
`;
